import {Controller} from "stimulus"

export default class extends Controller {
  connect() {
      if ($("#web_applicant_veteran_yes").is(':checked') == true) {
          $( "#vetsection" ).show();
      } else {
          $( "#vetsection" ).hide();
      };
  }
    yesveteran() {
       if (event.target.value == "yes") {
         $( "#vetsection" ).show();
        }
    }

    noveteran() {
       if (event.target.value == "no") {
         $( "#vetsection" ).hide();
        }
    }



  }
